import { render, staticRenderFns } from "./mercado_publico.vue?vue&type=template&id=2b514b27"
import script from "./mercado_publico.vue?vue&type=script&lang=js"
export * from "./mercado_publico.vue?vue&type=script&lang=js"
import style0 from "./mercado_publico.vue?vue&type=style&index=0&id=2b514b27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports